module.exports = __webpack_public_path__ + "images/psp/Bicycle/how-to-prepare-bike-for-storage.png";